import { httpRequest } from "../../http";

export class CommandAssignTeamMemberToEngagement {

    async run(engagementId: number,employeeId: number, roleId: number) {
        
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/team/`
        const body = {
            team:[
                {
                    employee: {
                        id: employeeId
                    },
                    role: {
                        id: roleId
                    }
                }
            ]
        }
        try {
            const response = await httpRequest<any>(url, { method: "PATCH", body });
            return response
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

}
